import React from 'react';
import { Link } from 'react-router-dom';
import { SectionHeading } from '../ui/SectionHeading';
import { Card } from '../ui/Card';
import { WrenchIcon, ZapIcon, ShieldCheckIcon, LeafIcon, ArrowRightIcon } from 'lucide-react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
const cardIcons = [WrenchIcon, ZapIcon, ShieldCheckIcon, LeafIcon];
// Each focus card maps to a directory filter slug
const cardFilters = ['oilfield', 'electrical', 'compliance', 'methane'];
export function NicheFocus() {
  const {
    lang
  } = useLang();
  const t = dictionary.focus;
  const cards = t.cards[lang];
  return <section id="focus" className="py-24 md:py-32 bg-white" data-id="element-430">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-431">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-432" />

        <div className="mt-14 grid md:grid-cols-2 gap-5" data-id="element-433">
          {cards.map((c, i) => {
          const Icon = cardIcons[i];
          return <Link key={c.title} to={`/suppliers?focus=${cardFilters[i]}`} className="block focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/60 rounded-md" data-id="element-434">
                <Card hover delay={i * 0.06} className="p-7 md:p-9 h-full group cursor-pointer" data-id="element-435">
                  <div className="flex items-start justify-between mb-5" data-id="element-436">
                    <div className="w-11 h-11 flex items-center justify-center bg-navy-deep rounded-sm" data-id="element-437">
                      <Icon className="w-5 h-5 text-gold" data-id="element-438" />
                    </div>
                    <span className="font-mono text-[11px] text-slate-400 tracking-wider" data-id="element-439">
                      {t.categoryLabel[lang]} · 0{i + 1}
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl text-navy-deep leading-tight mb-3" data-id="element-440">
                    {c.title}
                  </h3>
                  <div className="h-px bg-slate-200 my-4" data-id="element-441" />
                  <p className="text-[14.5px] text-slate-600 leading-relaxed" data-id="element-442">
                    <span className="font-medium text-navy-deep" data-id="element-443">
                      {t.examplesLabel[lang]}
                    </span>{' '}
                    {c.examples}
                  </p>
                  <div className="mt-5 flex items-center gap-2 text-[13px] font-medium text-gold-deep group-hover:gap-3 transition-all" data-id="element-444">
                    {t.exploreSuppliers[lang]}
                    <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-445" />
                  </div>
                </Card>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}